export type BulkSelectableRow = {
  id: number;
  canApprove?: boolean;
};

export function getPageSelectableIds(rows: BulkSelectableRow[]): number[] {
  return rows.filter((row) => row.canApprove === true).map((row) => row.id);
}

export function isMasterCheckboxChecked(
  pageIds: number[],
  selectedIds: Set<number>,
): boolean {
  if (pageIds.length === 0) {
    return false;
  }
  return pageIds.every((id) => selectedIds.has(id));
}

export function togglePageSelection(
  pageIds: number[],
  selectedIds: Set<number>,
): Set<number> {
  const next = new Set(selectedIds);
  const selectAll = !isMasterCheckboxChecked(pageIds, selectedIds);

  if (selectAll) {
    pageIds.forEach((id) => next.add(id));
  } else {
    pageIds.forEach((id) => next.delete(id));
  }

  return next;
}
